import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import './Under18.css';
import Fade from 'react-reveal/Fade';
import { setDigitalData } from '../../Utilities/Utils.js';

class Under18 extends Component {

    componentDidMount(){
        this.props.DGRBackgroundStore.showBlurAndHeader()

        if (this.props.DGRStore.debugMode === false){
            //REQUIRE USER 
            if (!this.props.DGRStore.values.email){
                this.props.DGRStore.clearValues()
                return this.props.history.push('');
            }
        }
        setDigitalData( 'under 18', this.props.DGRStore.club_number );
    }
    parentPressed = (e) => {
        this.props.history.push('guardian');
    }
    alonePressed= (e) => {
        this.props.DGRStore.clearValues()
        this.props.history.push('');

    }
    render(){
        return(
			<div className="under18">
            <Fade>
			<div className="under18Body">

                <div className="dgrTitleText">
                <h2>Guardian required to continue</h2> 
                </div>
                <div className="dgrTitleSubText">
                    <div className="subText">
                        Must be at least 18 years old (19 in NE). Parent or Guardian must be present to visit 24 Hour Fitness club if under 18 years of age.
                    </div>
                </div>
                <div className="dgrTitleSubText">
                    <div className="subText">
                       Click next to continue only if a parent or guardian is present. 
                    </div>
                </div>
                <button className="grayButton" onClick={this.alonePressed}>
                   Quit Signup 
                </button>
                <button className="bigButton" onClick={this.parentPressed}>
                    Next >
                </button>
                <br/>
            </div>
            </Fade>
            </div>
		)
		}
}

Under18 = inject('DGRStore', 'DGRBackgroundStore')(observer(Under18))     
export default Under18



// WEBPACK FOOTER //
// ./src/components/DGR/Under18/Under18.js